import { getErrorAsString } from '@notes/webintegrations-common'
import { Log } from './logger/Log'

export class FlushNewUserTelemetry {
  static totalSyncNotes: number| undefined
  static totalDbNotes: number | undefined
  static isExistingShorelineFeedUser: boolean| undefined

  static eventHandler(event: CustomEvent): void {
    try {
      const msgPayload = event.detail

      if (!msgPayload) {
        return
      }

      let parsedMessage = msgPayload
      if (typeof msgPayload === 'string') {
        parsedMessage = JSON.parse(parsedMessage)
      }

      if (!parsedMessage.MessageId) {
        return
      }

      switch (parsedMessage.MessageId) {
        case 'TotalSyncNotes':
          this.totalSyncNotes = parsedMessage.Value
          break
        case 'TotalDbNotes':
          this.totalDbNotes = parsedMessage.Value
          break
        case 'isExistingShorelineFeedUser':
          this.isExistingShorelineFeedUser = parsedMessage.Value
          break
        default:
          Log.logger.info('Unhandled message id in flushnewusertelemetry' + parsedMessage.MessageId)
      }

      if (this.totalDbNotes !== undefined && this.totalSyncNotes !== undefined && this.isExistingShorelineFeedUser !== undefined) {
        // minimum value of totalSyncNotes is 1
        if (!this.isExistingShorelineFeedUser && (this.totalDbNotes + this.totalSyncNotes) <= 1) {
          Log.logger.logReportData('NewONEcosytemShoreLineFeedUser', false /* isCriticalEvent */)
        }
      }
    } catch (error) {
      Log.logger.error(`FlushNewUserTelemetry event handler threw an error ${getErrorAsString(error)}`)
      return
    }
  }
}
